import { render, staticRenderFns } from "./CodaSplitModal.vue?vue&type=template&id=66625d22&scoped=true"
import script from "./CodaSplitModal.vue?vue&type=script&lang=ts"
export * from "./CodaSplitModal.vue?vue&type=script&lang=ts"
import style0 from "./CodaSplitModal.vue?vue&type=style&index=0&id=66625d22&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66625d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66625d22')) {
      api.createRecord('66625d22', component.options)
    } else {
      api.reload('66625d22', component.options)
    }
    module.hot.accept("./CodaSplitModal.vue?vue&type=template&id=66625d22&scoped=true", function () {
      api.rerender('66625d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/CodaSplitModal.vue"
export default component.exports